import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const HeadlineWithText = ({ blok }) => (
    
    <div className="headlinewithtext-wrap" {...storyblokEditable(blok)}>
      <h2 className="text-2xl headlinewithtext-headline">{blok.subheadline}</h2>
      
      <p className="headlinewithtext-text">
        {blok.text}
      </p>
  </div>
      
);

export default HeadlineWithText; 